// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Mo-z","giftOrPromoSelector":"No-z","disabled":"Oo-z","subTitle":"Po-z","selectShipAddressMessage":"Qo-z","changePayment":"Ro-z"};